module.exports = __webpack_public_path__ + "sunsemweb/img/DSC_1697.94c6396a.png";